export const SetProcedureFilter = 'filter/procedure/SET'
export const SetRecordFilter = 'filter/record/SET'
export const SetTaskFilter = 'filter/task/SET'
export const SetDocumentsFilter = 'filter/documents/SET'
export const SetAccessRequestFilter = 'filter/accessRequest/SET'
export const SetBreachFilter = 'filter/breach/SET'
export const SetCompanyFilter = 'filter/company/SET'
